import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import crmHero from "../assets/Hero/crm-hero.jpg"; // Replace with your hero image
import crmImage from "../assets/Hero/CRM.jpg"; // Replace with your CRM image
import "../assets/css/crmSolutionsPage.css";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

// JSON data for headings and paragraphs
const crmData = {
  hero: {
    title: "CRM Solutions",
    subtitle: "Enhance Customer Relationships with Advanced CRM Systems",
  },
  introduction: {
    heading: "Why CRM Solutions Matter",
    paragraphs: [
      "Customer Relationship Management (CRM) systems help businesses manage interactions with current and potential customers, improving relationships and driving sales growth.",
      "Our CRM solutions are designed to streamline customer management, enhance communication, and provide actionable insights for your business.",
    ],
  },
  cta: {
    heading: "Ready to Transform Your Customer Relationships?",
    text: "Contact us today to learn more about our CRM Solutions and how we can help your business thrive.",
  },
};

export const CRMSolutionsPage = ({ data }) => {
  const crmRef = useRef(null);
  const navigate = useNavigate(); // Initialize useNavigate

  useEffect(() => {
    const elements = crmRef.current.querySelectorAll(".crm-animate");

    gsap.fromTo(
      elements,
      { y: 100, opacity: 0 },
      {
        y: 0,
        opacity: 1,
        duration: 1.0,
        ease: "power3.out",
        stagger: 0.2,
        scrollTrigger: {
          trigger: crmRef.current,
          start: "top 80%",
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  // Function to handle navigation
  const handleContactClick = () => {
    navigate("/contact"); // Navigate to the contact page
  };

  return (
    <div id="crm-page" ref={crmRef}>
      {/* Hero Section */}
      <div
        className="crm-hero-section"
        style={{ backgroundImage: `url(${crmHero})` }}
      >
        <h1 className="crm-animate">{crmData.hero.title}</h1>
        <p className="crm-animate">{crmData.hero.subtitle}</p>
      </div>

      {/* Introduction Section */}
      <div className="container crm-introduction">
        <div className="row">
          <div className="col-md-6">
            <h2 className="crm-animate">{crmData.introduction.heading}</h2>
            {crmData.introduction.paragraphs.map((paragraph, index) => (
              <p key={index} className="crm-animate">
                {paragraph}
              </p>
            ))}
          </div>
          <div className="col-md-6 crm-image-container">
            <img
              src={crmImage}
              className="img-fluid crm-animate"
              alt="CRM Solutions"
            />
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      {/* <div className="container crm-cta">
        <h2 className="crm-animate">{crmData.cta.heading}</h2>
        <p className="crm-animate">{crmData.cta.text}</p>
        <button
          className="btn btn-primary crm-animate"
          onClick={handleContactClick} // Add onClick handler
        >
          Contact Us
        </button>
      </div> */}
    </div>
  );
};